import React from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const HOST_URL = process.env.REACT_APP_HOST_URL || "http://localhost:8000";

const LoginWithMS: React.FC = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    window.location.href = `${HOST_URL}/api/v1/auth/login/microsoft`;
  };

  return (
    <div className="login-container">
      {/* 왼쪽: 로그인 폼 */}
      <div className="login-left">
        <div className="login-box">
          <div className="login-header">
            <img src="/logo192.png" alt="Logo" className="login-logo" />
            <span className="login-brand">애널리틱스</span>
          </div>

          <h1 className="login-title">Welcome Back</h1>
          <p className="login-subtitle">
            Microsoft 회사 계정으로 로그인하여
            <br />
            대시보드에 접속하세요
          </p>

          <button className="ms-login-button" onClick={handleLogin}>
            <img
              src="/microsoft-logo.svg"
              alt="Microsoft"
              className="ms-login-icon"
            />
            <span>Microsoft로 계속하기</span>
          </button>

          <button className="guest-login-button" onClick={() => navigate("/login/guest")}>
            게스트 로그인
          </button>

          <p className="login-footer">
            Avatye 임직원 전용 서비스입니다.
            <br />
            @avatye.com 계정으로만 접속할 수 있습니다.
          </p>
        </div>
      </div>

      {/* 오른쪽: 장식 영역 */}
      <div className="login-right" />
    </div>
  );
};

export default LoginWithMS;

